function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.14282 7.23141L9.75282 11.1893C9.82916 11.229 9.91393 11.2497 9.99997 11.2497C10.086 11.2497 10.1708 11.229 10.2471 11.1893L17.8571 7.23213V14.1071C17.8571 14.7001 17.6303 15.2706 17.2231 15.7016C16.8158 16.1326 16.2591 16.3914 15.6671 16.425L15.5357 16.4286H4.46425C3.8713 16.4286 3.3008 16.2017 2.8698 15.7945C2.4388 15.3873 2.17996 14.8306 2.14639 14.2386L2.14282 14.1071V7.23141ZM4.46425 3.57141H15.5357C16.1286 3.57137 16.6991 3.79824 17.1301 4.20546C17.5611 4.61269 17.82 5.16941 17.8535 5.76141L17.8571 5.89284V6.02427L9.99997 10.11L2.14282 6.02427V5.89284C2.14278 5.29988 2.36965 4.72939 2.77687 4.29839C3.1841 3.86739 3.74082 3.60855 4.33282 3.57498L4.46425 3.57141H15.5357H4.46425Z",
  fill: "black"
});

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.58476c72.svg";
export { ForwardRef as ReactComponent };